module.exports = __webpack_public_path__ + "3074b8b2c965d64e9f31898900cf8d74.svg";